/**
 * Admin-Users badge store.
 * Drives the live count on the "Users" admin tile on `/`.
 */

import { create } from 'zustand';

interface UserBadgesState {
  lockedOut: number;
  setFromMetrics: (m: Partial<Pick<UserBadgesState, 'lockedOut'>>) => void;
  applyDelta: (m: Partial<Pick<UserBadgesState, 'lockedOut'>>) => void;
  reset: () => void;
}

const EMPTY = { lockedOut: 0 };
const clamp = (n: number) => (n < 0 ? 0 : n);

export const useUserBadgesStore = create<UserBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) => set({ lockedOut: clamp(m.lockedOut ?? 0) }),
  applyDelta: (m) =>
    set((state) => ({ lockedOut: clamp(state.lockedOut + (m.lockedOut ?? 0)) })),
  reset: () => set(EMPTY),
}));
